import { datadogLogs } from '@datadog/browser-logs';

let isInitialized = false;

const BLOCKED_REGEX = [
  /error POST https:\/\/api\.segment\.io/,
  /The play\(\) request was interrupted by a call to pause\(\)/,
  /Error sending segment performance metrics/,
];

export const logger = {
  init: () => {
    if (isInitialized) return;
    if (import.meta.env.VITE_DD_ENABLE == 'true') {
      isInitialized = true;
      datadogLogs.init({
        clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
        site: import.meta.env.VITE_DD_SITE,
        beforeSend: (event) => {
          if (BLOCKED_REGEX.some((regex) => regex.test(event?.message))) {
            return false;
          }
          return true;
        },
        service: import.meta.env.VITE_DD_SERVICE,
        version: import.meta.env.VITE_COMMIT_HASH,
        env: import.meta.env.VITE_DD_ENVIRONMENT,
        sessionSampleRate: parseInt(import.meta.env.VITE_DD_SAMPLE_RATE),
        forwardErrorsToLogs: true,
      });
    }
  },
  info: (...args: Parameters<typeof datadogLogs.logger.info>) =>
    datadogLogs.logger.info(...args),
  error: (...args: Parameters<typeof datadogLogs.logger.error>) =>
    datadogLogs.logger.error(...args),
  warn: (...args: Parameters<typeof datadogLogs.logger.warn>) =>
    datadogLogs.logger.warn(...args),
  debug: (...args: Parameters<typeof datadogLogs.logger.debug>) =>
    datadogLogs.logger.debug(...args),
};
